import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Modal} from 'antd'

class LabelPreview extends Component {
    state = {
        visible: false,
    }

    _showModal = () => {
        this.setState({
            visible: true,
        })
    }

    _hideModal = () => {
        this.setState({
            visible: false,
        })
    }

    render() {
        const {printableUrl} = this.props
        const {visible} = this.state

        return (
            <td className='LabelPreview'>
                {
                    printableUrl
                        ?
                        <>
                            <span className='text-primary cursor-pointer' onClick={this._showModal}>View</span>
                            <Modal visible={visible} closable={false} centered={true} footer={null} width={1200}
                                   onCancel={this._hideModal}>
                                <img src={printableUrl} alt='Preview label'/>
                            </Modal>
                        </>
                        :
                        <i className='text-muted'>Not available</i>
                }
            </td>
        )
    }
}

LabelPreview.defautlProps = {
    printableUrl: '',
}

LabelPreview.propTypes = {
    printableUrl: PropTypes.string,
}

export default LabelPreview
